import { product } from '../constants'

const index = {
  addProduct: product.add,
  addProducts: product.addProducts,
  deleteProduct: product.remove,
  deleteAllProducts: product.remove_all,
  addProductsBulkPending: `${product.addBulk}_PENDING`,
  addProductsBulkFulfilled: `${product.addBulk}_FULFILLED`,
  addProductsBulkRejected: `${product.addBulk}_REJECTED`
}

const reducerKey = 'products'

export const handleProducts: ActionProps = {
  [index.addProduct]: ({ draft, action }) => {
    const product = action.payload
    const values = action.values as HandleAddProduct
    const productWithSubpublisherId = addSubpublisherId({
      product,
      sub_publisher_id: values?.subPublisherIds
    })

    const oldSelectedProducts = draft.campaign[reducerKey].selectedProducts

    draft.campaign[reducerKey].selectedProducts = [
      productWithSubpublisherId,
      ...oldSelectedProducts
    ]
  },
  [index.addProducts]: ({ draft, action }) => {
    const newProducts = action.payload
    const oldSelectedProducts = draft.campaign[reducerKey].selectedProducts

    // Filtra para evitar duplicatas
    const uniqueProducts = newProducts.filter(
      newProduct =>
        !oldSelectedProducts.some(
          existingProduct =>
            existingProduct.id === newProduct.id ||
            existingProduct.product_sku === newProduct.product_sku
        )
    )

    draft.campaign[reducerKey].selectedProducts = [
      ...uniqueProducts,
      ...oldSelectedProducts
    ]
  },
  [index.deleteProduct]: ({ draft, action }) => {
    const oldSelectedProducts = draft.campaign[reducerKey].selectedProducts
    const removeId = action.payload.id

    const removeSku = action.payload.product_sku

    const filteredProducts = oldSelectedProducts.filter(item =>
      item.id ? item.id !== removeId : item.product_sku !== removeSku
    )

    draft.campaign[reducerKey].selectedProducts = filteredProducts
  },
  [index.deleteAllProducts]: ({ draft, action }) => {
    const isEdit = action.payload
    const oldSelectedProducts = draft.campaign[reducerKey].selectedProducts

    if (!isEdit) {
      draft.campaign[reducerKey].selectedProducts = []
    } else {
      const products = oldSelectedProducts.filter(
        item => item.item_disabled === true
      )

      draft.campaign[reducerKey].selectedProducts = products
    }
  },
  //
  [index.addProductsBulkPending]: ({ draft }) => {
    draft.campaign[reducerKey].loadingAddBulk = true
    draft.campaign[reducerKey].rejectedProducts = null
  },
  //
  [index.addProductsBulkFulfilled]: ({ draft, action }) => {
    const oldSelectedProducts = draft.campaign[reducerKey].selectedProducts

    const addedProducts = action.payload.data
    const values = action.values as HandleProductsSearchActionValues

    const addedProductsWithSubpublisherId = addedProducts.map(product =>
      addSubpublisherId({
        product,
        sub_publisher_id: values?.subPublisherIds
      })
    )

    const findIndexOffer = offer =>
      oldSelectedProducts.findIndex(item =>
        offer.id ? offer.id === item.id : offer.product_sku === item.product_sku
      )

    const selectedOffers = addedProductsWithSubpublisherId.filter(
      item => findIndexOffer(item) === -1
    )

    // Handle rejected products
    const allRequestedProduct = values.products
    const queryKey = values.queryKey || 'product_skus'

    const keyToCompare = {
      product_skus: 'product_sku',
      product_gtins: 'gtins',
      product_additional_references: 'additional_references',
      product_reference_codes: 'product_reference_codes'
    }

    const rejectedProducts = allRequestedProduct.filter(item => {
      if (queryKey === 'product_skus') {
        return !(
          addedProductsWithSubpublisherId.findIndex(
            offer => offer.product_sku === item || offer.id === item
          ) > -1
        )
      }

      if (
        queryKey === 'product_gtins' ||
        queryKey === 'product_additional_references' ||
        queryKey === 'product_reference_codes'
      ) {
        return !(
          addedProductsWithSubpublisherId.findIndex(offer =>
            offer[keyToCompare[queryKey]]?.includes(item)
          ) > -1
        )
      }
    })

    draft.campaign[reducerKey].selectedProducts = [
      ...selectedOffers,
      ...oldSelectedProducts
    ]

    draft.campaign[reducerKey].rejectedProducts = rejectedProducts

    draft.campaign[reducerKey].loadingAddBulk = false
  },
  [index.addProductsBulkRejected]: ({ draft }) => {
    draft.campaign[reducerKey].loadingAddBulk = false
  }
}

function addSubpublisherId({
  product,
  sub_publisher_id
}: {
  product: PublisherProduct
  sub_publisher_id: string
}) {
  return {
    ...product,
    sub_publisher_id
  }
}
